export default "__VITE_ASSET__WuK$FoiV__"